// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2106":"13c404c4","3698":"13c404c4","4382":"13c404c4","5301":"13c404c4","5454":"13c404c4","6929":"13c404c4"}[chunkId] + ".chunk.css";
};